// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__271M_","title":"AfterBackImages_title__1mKM6","images":"AfterBackImages_images__2e7gn"};